var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#30454D;}\n\t.st1{fill:#203135;}\n\t.st2{fill:#6CD9DB;}\n\t.st3{fill:#FEDD58;}\n\t.st4{fill:#FEA12C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480,0h-70H30C13.4,0,0,13.4,0,30v30c0,16.6,13.4,30,30,30h110c11,0,20,9,20,20v70c0,16.6,13.4,30,30,30h10 c5.5,0,10,4.5,10,10v20v20c0,16.6,13.4,30,30,30h40c5.5,0,10,4.5,10,10v10c0,16.6,13.4,30,30,30h70c11,0,20,9,20,20v110 c0,16.6,13.4,30,30,30h30c16.6,0,30-13.4,30-30V90V20C500,9,491,0,480,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.3,92.6l-63.6,63.6c-3.9,3.9-10.2,3.9-14.1,0l-17.7-17.7c-3.9-3.9-3.9-10.2,0-14.1l63.6-63.6 c7.8-7.8,20.5-7.8,28.3,0l3.5,3.5C302.1,72.1,302.1,84.7,294.3,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.8,238.1l-63.6,63.6c-3.9,3.9-10.2,3.9-14.1,0l-17.7-17.7c-3.9-3.9-3.9-10.2,0-14.1l63.6-63.6 c7.8-7.8,20.5-7.8,28.3,0l3.5,3.5C448.6,217.6,448.6,230.3,440.8,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.4,116.8L402,66.2c3.9-3.9,10.2-3.9,14.1,0l17.7,17.7c3.9,3.9,3.9,10.2,0,14.1l-50.7,50.7 c-7.8,7.8-20.5,7.8-28.3,0l-3.5-3.5C343.6,137.3,343.6,124.7,351.4,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411,470v-90h30c5.5,0,10,4.5,10,10v110h-10C424.4,500,411,486.6,411,470z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M434.6,97.7c-8.8,8.8-23,8.8-31.8,0c-8.8-8.8-8.8-23,0-31.8c8.8-8.8,40.7-26.5,49.5-17.7 C461,57,443.4,89,434.6,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,90h90V60c0-5.5-4.5-10-10-10H0l0,10C0,76.6,13.4,90,30,90z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130.2,271l-74.2,74.2c-3.9,3.9-10.2,3.9-14.1,0l-7.1-7.1c-3.9-3.9-3.9-10.2,0-14.1l74.2-74.2 c3.9-3.9,10.2-3.9,14.1,0l7.1,7.1C134.1,260.7,134.1,267.1,130.2,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.4,391.2l-74.2,74.2c-3.9,3.9-10.2,3.9-14.1,0l-7.1-7.1c-3.9-3.9-3.9-10.2,0-14.1l74.2-74.2 c3.9-3.9,10.2-3.9,14.1,0l7.1,7.1C254.3,380.9,254.3,387.3,250.4,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.7,419.3l-74.2,74.2c-3.9,3.9-10.2,3.9-14.1,0l-7.1-7.1c-3.9-3.9-3.9-10.2,0-14.1l74.2-74.2 c3.9-3.9,10.2-3.9,14.1,0l7.1,7.1C105.6,409.1,105.6,415.4,101.7,419.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161.8,359.2l-14.1,14.1c-3.9,3.9-10.2,3.9-14.1,0l-7.1-7.1c-3.9-3.9-3.9-10.2,0-14.1l14.1-14.1 c3.9-3.9,10.2-3.9,14.1,0l7.1,7.1C165.7,349,165.7,355.3,161.8,359.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.eacd4826208715a97d4fb3d87e628774.svg";
export { ForwardRef as ReactComponent };